import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { CategoryService } from '../../core/services';
import { Category } from '../../core/models';

@Component({
  selector: 'app-category-list',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {
  categories: Category[] = [];
  loading = true;
  error: string | null = null;

  constructor(
    private categoryService: CategoryService,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit(): void {
    // Imposta i meta tag per la pagina Categorie
    this.title.setTitle('Categorie - AI PodLab');
    this.meta.updateTag({ name: 'description', content: 'Esplora tutti gli episodi del podcast AI PodLab organizzati per categoria: scienza, tecnologia, intelligenza artificiale e molto altro.' });
    this.meta.updateTag({ property: 'og:title', content: 'Categorie - AI PodLab' });
    this.meta.updateTag({ property: 'og:description', content: 'Esplora tutti gli episodi del podcast AI PodLab organizzati per categoria: scienza, tecnologia, intelligenza artificiale e molto altro.' });
    
    this.loadCategories();
  }

  loadCategories(): void {
    this.loading = true;
    this.error = null;

    this.categoryService.getAll().subscribe({
      next: (response) => {
        if (response.success) {
          this.categories = response.data;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading categories:', err);
        this.error = 'Errore nel caricamento delle categorie';
        this.loading = false;
      }
    });
  }
}
